import { Navigate, useNavigate, useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import PatientInformationHeader from '../../components/Patient/PatientInformationHeader';
import {
    useGetPatientDetailsQuery,
    useGetPatientOrdersQuery,
    useUpdateMedOrderMutation,
    useUpdateOrderStatusMutation,
} from '../../features/patient/patientService';
import OrderMedicationForm from '../../components/Orders/OrderMedicationForm';
import { OrderStatusEnum } from '../../models/PatientModels';
import { Button } from 'antd';
import useOrderToast from '../../hooks/useOrderToast';
import ConfirmationModal from '../../components/Orders/ConfirmationModal';
import { useState } from 'react';

const UpdateOrder = () => {
    const navigate = useNavigate();
    const { id: patientId = '', orderId = '' } = useParams();

    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailModalOpen, setIsFailModalOpen] = useState(false);


    const { toast } = useOrderToast();

    const { data: patientOrders, isLoading } = useGetPatientOrdersQuery({
        patientId: patientId,
        orderStatus: OrderStatusEnum.Draft,
    });
    const { data: patientDetails, isLoading: patientDetailsLoading } =
        useGetPatientDetailsQuery({ id: patientId });

    const [updateMedOrder, { isLoading: updatingMedOrder }] =
        useUpdateMedOrderMutation();

    const [updateOrderStatus, { isLoading: isUpdatingOrderStatus }] =
        useUpdateOrderStatusMutation();

    const order = patientOrders?.find(
        (patientOrder) => patientOrder.id === orderId,
    );

    if (!isLoading && !order)
        return <Navigate to={`/patient/${patientId}/add-new-medication`} />;

    const onSubmit = async (data: any) => {
        var res: any = await updateMedOrder({ ...data, orderId: orderId });

        if (res.data) {
            setIsSuccessModalOpen(true);
        }
        else {
            setIsFailModalOpen(true);
        }
    };

    const onDelete = async () => {
        await updateOrderStatus({
            orderStatus: OrderStatusEnum.Inactive,
            orderId: orderId,
            patientId,
        });
        toast('The order deletion was successful.', 'success');
    };

    

    return (
        <div>
            <PageTitle
                title="Update Medication"
                onClick={() =>
                    navigate(`/patient/${patientId}/add-new-medication`)
                }
            />
            <div className="mx-5">
                {patientDetails && (
                    <PatientInformationHeader
                        patient={patientDetails}
                        navigate={() => navigate(-2)}
                    />
                )}
                <OrderMedicationForm
                    order={order}
                    cancelButton={
                        <Button
                            danger
                            onClick={onDelete}
                            className="me-4"
                            loading={isUpdatingOrderStatus}
                            style={{
                                width: 120,
                            }}
                            shape="round"
                        >
                            Delete
                        </Button>
                    }
                    onSubmit={onSubmit}
                    isSubmitting={updatingMedOrder}
                    submitLabel="Save to Queue"
                />
            </div>

            <ConfirmationModal
                isOpen={isSuccessModalOpen}
                isSuccess={true}
                onClose={() => setIsSuccessModalOpen(false)}
                title="Successful!"
                message="The medication details were successfully updated."
                primaryButtonText="View Medication Queue"
                secondaryButtonText="Add New Medication"
                onPrimaryButtonLinkToClick={()=> navigate(-1)}
                onSecondaryButtonLinkClick={()=> {
                    navigate(`/patient/${patientId}/med-order-create`)
                }}
            />

            <ConfirmationModal
                isOpen={isFailModalOpen}
                isSuccess={false}
                onClose={() => setIsFailModalOpen(false)}
                title="Failed"
                message="The medication details failed to update."
                primaryButtonText="Try Again"
                secondaryButtonText="Add New Medication"
                onPrimaryButtonLinkToClick={()=> navigate(0)}
                onSecondaryButtonLinkClick={()=> {
                    navigate(`/patient/${patientId}/med-order-create`)
                }}
            />      
        </div>
    );
};

export default UpdateOrder;
